import React from "react"
import "./footer.styles.scss"

const Footer = () => {
  return (
    <div className="footer">
      <p>Developed by jarryingnut.eth © 2022</p>
    </div>
  )
}

export default Footer
